import { Component } from '@angular/core';

import { Gender } from '@camelot/services';
import { GenderComponent } from '@camelot/ui';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-gender-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [GenderComponent],
  template: `
    @if (this.value) {
      <div class="flex-start align-center" style="height: 100%">
        <cam-gender class="d-flex" [gender]="this.value"></cam-gender>
      </div>
    }
  `,
})
export class GridGenderCellComponent extends AbstractCellComponent<any, Gender> {}
